import { render, staticRenderFns } from "./TransactionCompleting.vue?vue&type=template&id=58e6604c&"
import script from "./TransactionCompleting.vue?vue&type=script&lang=js&"
export * from "./TransactionCompleting.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCompleting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports